// src/utils/productValidation.js

export const validateProduct = (formData, config) => {
    let errors = {};
    let valid = true;

    // ✅ 1. GET ALL FIELDS FROM CONFIG
    const allFields = {
        basic: config?.fields?.basic || [],
        category: config?.fields?.category || [],
        pricing: config?.fields?.pricing || [],
        inventory: config?.fields?.inventory || [],
        tax: config?.fields?.tax || [],
        service: config?.fields?.service || [],
        description: config?.fields?.description || [],
    };

    // ✅ 2. FLATTEN ALL FIELDS
    const visibleFields = [
        ...allFields.basic,
        ...allFields.category,
        ...allFields.pricing,
        ...allFields.inventory,
        ...allFields.tax,
        ...allFields.service,
        ...allFields.description,
    ];

    console.log("🔍 Visible Fields:", visibleFields);

    // ✅ 3. FIELD VALIDATION RULES (Dynamic)
    const fieldRules = {
        // ===== BASIC FIELDS =====
        user_id: {
            required: true,
            message: "User is required",
            validate: (value) => value && value !== ''
        },
        product_name: {
            required: true,
            message: "Product Name is required",
            validate: (value) => value && value.trim() !== ''
        },
        brand_id: {
            required: false,
            message: "Brand is required",
            validate: (value) => value && value !== ''
        },
        sku: {
            required: false,
            message: "SKU is required",
            validate: (value) => value && value.trim() !== ''
        },
        barcode: {
            required: false,
            message: "Barcode is required",
            validate: (value) => value && value.trim() !== ''
        },
        model: {
            required: false,
            message: "Model is required",
            validate: (value) => value && value.trim() !== ''
        },
        serial_number: {
            required: false,
            message: "Serial Number is required",
            validate: (value) => value && value.trim() !== ''
        },
        warranty: {
            required: false,
            message: "Warranty is required",
            validate: (value) => value && value.trim() !== ''
        },
        specifications: {
            required: false,
            message: "Specifications are required",
            validate: (value) => value && value.trim() !== ''
        },
        processor: {
            required: false,
            message: "Processor is required",
            validate: (value) => value && value.trim() !== ''
        },
        ram: {
            required: false,
            message: "RAM is required",
            validate: (value) => value && value.trim() !== ''
        },
        storage: {
            required: false,
            message: "Storage is required",
            validate: (value) => value && value.trim() !== ''
        },
        display_size: {
            required: false,
            message: "Display Size is required",
            validate: (value) => value && value.trim() !== ''
        },
        battery_capacity: {
            required: false,
            message: "Battery Capacity is required",
            validate: (value) => value && value.trim() !== ''
        },
        operating_system: {
            required: false,
            message: "Operating System is required",
            validate: (value) => value && value.trim() !== ''
        },
        power_rating: {
            required: false,
            message: "Power Rating is required",
            validate: (value) => value && value.trim() !== ''
        },
        voltage: {
            required: false,
            message: "Voltage is required",
            validate: (value) => value && value.trim() !== ''
        },
        material: {
            required: false,
            message: "Material is required",
            validate: (value) => value && value.trim() !== ''
        },
        dimensions: {
            required: false,
            message: "Dimensions are required",
            validate: (value) => value && value.trim() !== ''
        },
        weight: {
            required: false,
            message: "Weight is required",
            validate: (value) => value && value.trim() !== ''
        },
        color: {
            required: false,
            message: "Color is required",
            validate: (value) => value && value.trim() !== ''
        },
        size: {
            required: false,
            message: "Size is required",
            validate: (value) => value && value.trim() !== ''
        },

        // ===== CATEGORY FIELDS =====
        category_id: {
            required: true,
            message: "Category is required",
            validate: (value) => value && value !== ''
        },
        subcategory_id: {
            required: true,
            message: "Sub Category is required",
            validate: (value) => value && value !== ''
        },
        unit_id: {
            required: false,
            message: "Unit is required",
            validate: (value) => value && value !== ''
        },

        // ===== PRICING FIELDS =====
        purchase_price: {
            required: false,
            message: "Purchase Price is required",
            validate: (value) => value !== undefined && value !== null && value !== '' && Number(value) >= 0
        },
        selling_price: {
            required: false,
            message: "Selling Price is required",
            validate: (value) => value !== undefined && value !== null && value !== '' && Number(value) >= 0
        },
        mrp: {
            required: false,
            message: "MRP is required",
            validate: (value) => value !== undefined && value !== null && value !== '' && Number(value) >= 0
        },
        discount: {
            required: false,
            message: "Discount is required",
            validate: (value) => value !== undefined && value !== null && value !== '' && Number(value) >= 0
        },
        discount_type: {
            required: false,
            message: "Discount Type is required",
            validate: (value) => value && value !== ''
        },

        // ===== INVENTORY FIELDS =====
        min_stock_level: {
            required: false,
            message: "Minimum Stock is required",
            validate: (value) => value !== undefined && value !== null && value !== '' && Number(value) >= 0
        },
        reorder_level: {
            required: false,
            message: "Reorder Level is required",
            validate: (value) => value !== undefined && value !== null && value !== '' && Number(value) >= 0
        },

        // ===== TAX FIELDS =====
        gst_percentage: {
            required: false,
            message: "GST % is required",
            validate: (value) => value !== undefined && value !== null && value !== '' && Number(value) >= 0 && Number(value) <= 100
        },
        hsn_code: {
            required: false,
            message: "HSN Code is required",
            validate: (value) => value && value.trim() !== ''
        },

        // ===== SERVICE FIELDS =====
        service_type: {
            required: false,
            message: "Service Type is required",
            validate: (value) => value && value !== ''
        },
        service_duration: {
            required: false,
            message: "Service Duration is required",
            validate: (value) => value && value.trim() !== ''
        },
        ad_type: {
            required: false,
            message: "Ad Type is required",
            validate: (value) => value && value !== ''
        },
        platform: {
            required: false,
            message: "Platform is required",
            validate: (value) => value && value !== ''
        },
        reach: {
            required: false,
            message: "Reach is required",
            validate: (value) => value && value.trim() !== ''
        },
        duration: {
            required: false,
            message: "Campaign Duration is required",
            validate: (value) => value && value.trim() !== ''
        },
        deliverables: {
            required: false,
            message: "Deliverables are required",
            validate: (value) => value && value.trim() !== ''
        },
        booking_required: {
            required: false,
            message: "Booking Required is required",
            validate: (value) => value && value !== ''
        },

        // ===== FOOD FIELDS =====
        cuisine_type: {
            required: false,
            message: "Cuisine Type is required",
            validate: (value) => value && value !== ''
        },
        dietary_info: {
            required: false,
            message: "Dietary Info is required",
            validate: (value) => value && value.trim() !== ''
        },
        spice_level: {
            required: false,
            message: "Spice Level is required",
            validate: (value) => value && value !== ''
        },
        prep_time: {
            required: false,
            message: "Preparation Time is required",
            validate: (value) => value && value.trim() !== ''
        },
        serving_size: {
            required: false,
            message: "Serving Size is required",
            validate: (value) => value && value.trim() !== ''
        },
        allergens: {
            required: false,
            message: "Allergens are required",
            validate: (value) => value && value.trim() !== ''
        },
        ingredients: {
            required: false,
            message: "Ingredients are required",
            validate: (value) => value && value.trim() !== ''
        },

        // ===== PROPERTY FIELDS =====
        property_type: {
            required: false,
            message: "Property Type is required",
            validate: (value) => value && value !== ''
        },
        property_size: {
            required: false,
            message: "Property Size is required",
            validate: (value) => value && value.trim() !== ''
        },
        bedrooms: {
            required: false,
            message: "Bedrooms are required",
            validate: (value) => value && value.trim() !== ''
        },
        bathrooms: {
            required: false,
            message: "Bathrooms are required",
            validate: (value) => value && value.trim() !== ''
        },
        furnished: {
            required: false,
            message: "Furnished status is required",
            validate: (value) => value !== undefined && value !== null
        },
        parking: {
            required: false,
            message: "Parking status is required",
            validate: (value) => value !== undefined && value !== null
        },
        locality: {
            required: false,
            message: "Locality is required",
            validate: (value) => value && value.trim() !== ''
        },

        // ===== MEDICINE FIELDS =====
        batch_number: {
            required: false,
            message: "Batch Number is required",
            validate: (value) => value && value.trim() !== ''
        },
        expiry_date: {
            required: false,
            message: "Expiry Date is required",
            validate: (value) => value && value !== ''
        },
        generic_name: {
            required: false,
            message: "Generic Name is required",
            validate: (value) => value && value.trim() !== ''
        },
        dosage: {
            required: false,
            message: "Dosage is required",
            validate: (value) => value && value.trim() !== ''
        },
        composition: {
            required: false,
            message: "Composition is required",
            validate: (value) => value && value.trim() !== ''
        },
        schedule: {
            required: false,
            message: "Schedule is required",
            validate: (value) => value && value !== ''
        },
        manufacturer: {
            required: false,
            message: "Manufacturer is required",
            validate: (value) => value && value.trim() !== ''
        },

        // ===== E-COMMERCE FIELDS =====
        color_ids: {
            required: false,
            message: "Colors are required",
            validate: (value) => value && value.length > 0
        },
        size_ids: {
            required: false,
            message: "Sizes are required",
            validate: (value) => value && value.length > 0
        },

        // ===== DESCRIPTION FIELDS =====
        description: {
            required: false,
            message: "Description is required",
            validate: (value) => value && value.trim() !== ''
        },
        short_description: {
            required: false,
            message: "Short Description is required",
            validate: (value) => value && value.trim() !== ''
        },
    };

    // ✅ 4. VALIDATE ONLY VISIBLE FIELDS
    visibleFields.forEach((fieldName) => {
        const rule = fieldRules[fieldName];
        if (!rule) return; // No validation rule

        const value = formData[fieldName];

        // ✅ Check if field is required and visible
        if (rule.required && !rule.validate(value)) {
            errors[fieldName] = rule.message;
            valid = false;
        }
    });

    // ✅ 5. VARIANT VALIDATIONS (Only if variants component is enabled)
    const hasVariants = config?.components?.variants === true;

    if (hasVariants && formData.variants && formData.variants.length > 0) {
        const variantConfig = config?.variant_fields || { required: [], optional: [] };
        const requiredVariantFields = variantConfig.required || [];

        formData.variants.forEach((variant, index) => {
            // ✅ SKU - Always required if variants exist
            if (!variant.sku) {
                errors[`variants.${index}.sku`] = 'SKU is required';
                valid = false;
            }

            // ✅ Required variant fields from config
            requiredVariantFields.forEach(field => {
                const value = variant[field];

                if (field === 'color_ids' && (!value || value.length === 0)) {
                    errors[`variants.${index}.color_ids`] = 'At least one color is required';
                    valid = false;
                }
                else if (field === 'size_ids' && (!value || value.length === 0)) {
                    errors[`variants.${index}.size_ids`] = 'At least one size is required';
                    valid = false;
                }
                else if (field === 'stock' && (value === undefined || value === null || value === '')) {
                    errors[`variants.${index}.stock`] = 'Stock is required';
                    valid = false;
                }
                else if (field === 'price' && (value === undefined || value === null || value === '')) {
                    errors[`variants.${index}.price`] = 'Price is required';
                    valid = false;
                }
                else if (field === 'ram' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.ram`] = 'RAM is required';
                    valid = false;
                }
                else if (field === 'storage' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.storage`] = 'Storage is required';
                    valid = false;
                }
                else if (field === 'imei' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.imei`] = 'IMEI is required';
                    valid = false;
                }
                else if (field === 'material' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.material`] = 'Material is required';
                    valid = false;
                }
                else if (field === 'model' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.model`] = 'Model is required';
                    valid = false;
                }
                else if (field === 'barcode' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.barcode`] = 'Barcode is required';
                    valid = false;
                }
                else if (field === 'weight' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.weight`] = 'Weight is required';
                    valid = false;
                }
                else if (field === 'dimensions' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.dimensions`] = 'Dimensions are required';
                    valid = false;
                }
                else if (field === 'warranty' && (!value || value.trim() === '')) {
                    errors[`variants.${index}.warranty`] = 'Warranty is required';
                    valid = false;
                }
            });

            // ✅ Price validation (if exists)
            if (variant.price !== undefined && variant.price !== null && variant.price !== '' && Number(variant.price) < 0) {
                errors[`variants.${index}.price`] = 'Invalid price';
                valid = false;
            }
        });
    }


    return {
        valid: Object.keys(errors).length === 0 && valid,
        errors,
    };
};